export default class MentionableModel {
  constructor(format) {
    this.format = format;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/MentionableModel', MentionableModel);